import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Icon } from 'coreOld/elements';

interface WrapperProps {
  marginBottom?: number;
  children?: ReactNode;
}

export const Wrapper = styled.ul<WrapperProps>`
  list-style: none;
  padding: 0 0 4px;
  margin: 0;
  font-size: 14px;
  font-style: italic;

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}
`;

interface ItemProps {
  boldOnHover?: boolean;
  children?: ReactNode;
}

export const Item = styled.li<ItemProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;

  ${({ boldOnHover }) =>
    boldOnHover &&
    css`
      :hover {
        font-weight: 500;
      }
    `}
`;

interface ClearIconProps {
  children?: ReactNode;
  onClick?: any;
}

export const ClearIcon = styled.div<ClearIconProps>`
  cursor: pointer;
`;

interface IProps {
  files: any[];
  removeFile?: (file: any) => void;
  marginBottom?: number;
}

const FileList = ({ files, removeFile, marginBottom }: IProps) => {
  if (!files || files?.length === 0) {
    return null;
  }

  return (
    <Wrapper marginBottom={marginBottom}>
      {files.map((file) => (
        <Item key={file.path || file.id} boldOnHover={!!removeFile}>
          {file.bucketFileName || file.name || file.fileName}

          {removeFile && (
            <ClearIcon onClick={() => removeFile(file)}>
              <Icon name={Icon.CLEAR} />
            </ClearIcon>
          )}
        </Item>
      ))}
    </Wrapper>
  );
};

export default FileList;
